import {StyleSheet, css} from 'aphrodite';
import React from 'react';

import {
  PUBLISHED_ANALYSIS_TEMPLATE_TOOLTIP_TEXT,
  getArchivedTooltipMessage,
} from 'analysis-tool/AnalysisToolMessages';
import {CanEditReturnValue, checkIsAnalysisArchived} from 'analysis-tool/EditAnalysisHelpers';
import AnalysisFlowchart from 'analysis-tool/flowchart/AnalysisFlowchart';
import {AnalysisFlowchartMode} from 'analysis-tool/flowchart/AnalysisFlowchartContext';
import {AnalysisTemplateGraphQL} from 'analysis-tool/templates/AnalysisTemplateTypes';

export function checkIsAnalysisTemplatePublished(
  analysisTemplate: AnalysisTemplateGraphQL
): CanEditReturnValue | null {
  if (analysisTemplate.publishedAt != null) {
    return {
      canEdit: false,
      message: PUBLISHED_ANALYSIS_TEMPLATE_TOOLTIP_TEXT,
    };
  }
  return null;
}

export function checkCanModifyAnalysisTemplate(
  analysisTemplate: AnalysisTemplateGraphQL
): CanEditReturnValue {
  return (
    checkIsAnalysisArchived(analysisTemplate, getArchivedTooltipMessage(analysisTemplate)) ??
    checkIsAnalysisTemplatePublished(analysisTemplate) ?? {canEdit: true, message: null}
  );
}

interface AnalysisFlowchartViewProps {
  analysisTemplate: AnalysisTemplateGraphQL;
}

/**
 * A flowchart representation of an analysisTemplate, as rendered full-screen in the template collections page.
 *
 * This view is read-only. When `ENABLE_ANALYSIS_TOOL_EDITABLE_TEMPLATES` is enabled, analysis templates are
 * edited in `<AnalysisFlowchartView>`.
 */
export default function AnalysisTemplateFlowchartView({
  analysisTemplate,
}: AnalysisFlowchartViewProps): JSX.Element {
  return (
    <div className={css(styles.wrapper)}>
      <div className={css(styles.flowchart)}>
        <AnalysisFlowchart
          analysis={analysisTemplate}
          mode={AnalysisFlowchartMode.STATIC}
          availableActions={[]}
          canModifyAnalysis={() => checkCanModifyAnalysisTemplate(analysisTemplate)}
        />
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    width: '100%',
    position: 'relative',
  },
  flowchart: {
    height: '100%',
    width: '100%',
  },
});
